import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'bc-user-required-modal',
  templateUrl: './user-required.modal.component.html',
  styleUrls: ['./user-required.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserRequiredModalComponent {}
